<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<div [formGroup]="testbedForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Name </mat-label>
    <input formControlName="identifier" matInput name="identifier" type="text">
    <mat-error *ngIf="testbedForm.controls.identifier?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Address </mat-label>
    <input matGoogleMapsAutocomplete formControlName="address" name="address" matInput
      [value]="_testbed.address ? _testbed.address : ''" type="text">
    <mat-error *ngIf="testbedForm.controls.address?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field *ngIf="!isEditing">
    <mat-label>Company </mat-label>
    <mat-select formControlName="company" name="company">
      <mat-option *ngIf="!loadingCompanies && companies.length === 0">
        No companies available.
      </mat-option>
      <mat-option *ngFor="let company of companies" [value]="company">
        {{company?.companyName}}
      </mat-option>
    </mat-select>
    <span *ngIf="loadingCompanies" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-error *ngIf="testbedForm.controls.company?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
    <mat-hint *ngIf="!loadingCompanies && companies.length === 0" class="color-warn">
      No companies available.
    </mat-hint>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="testbed = _testbed; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveTestbed()" [disabled]="testbedForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>